// extracted by mini-css-extract-plugin
module.exports = {"component":"Icon_component__13Pat","animated":"Icon_animated__1CZ_K","icon-spin":"Icon_icon-spin__2RGwA"};